"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2-premium/compiled/state/normal.js
// module id = 263
// module chunks = 0